import { Body, Button, Dialog, FormGroup, ISelectOption, Select, TextArea } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { createToast } from '../../../../../../FlashToaster';

const OTHER = 'Other';

const CLOSE_REASONS = [
  'Budgetary Constraints',
  'Candidate No-Show in Interviews/Assessments',
  'Candidate Non-Responsiveness',
  'Candidate Withdrawn',
  'Candidates Accepted Other Offers',
  'Change in Strategy',
  'Downsizing',
  'Hiring Freeze',
  'Incorrect Pledge Submission by Organisation',
  'Lack of Candidates to Review',
  'Lack of Organisational Engagement',
  'Lack of Ring-Fencing',
  'Non-Responsive',
  'Over Hired in Other Job Slates',
  'Poor Candidate Quality',
  'Reason Unknown',
  'Role Filled Internally',
  'Unaligned Recruitment Timeline',
  'Visa Sponsorship Issues',
  OTHER,
].map((reason) => ({ value: reason, label: reason }));

export function CloseJobDialog({ fetchData, job, handleClose, isOpen }) {
  const [selectedCloseOption, setSelectedCloseOption] = React.useState<string>();
  const [details, setDetails] = React.useState<string>('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSelect = (selectedItem: ISelectOption) => {
    setSelectedCloseOption(selectedItem.value);
  };

  const selectedOption = CLOSE_REASONS.find((option) => option.value === selectedCloseOption);
  const needsDetails = selectedCloseOption === OTHER;
  const canSubmit = selectedCloseOption && (!needsDetails || details.trim().length > 0);

  const handleSubmit = () => {
    setIsSubmitting(true);
    const closeKey = 'close-job';
    createToast({ type: 'success', key: closeKey, isLoading: true, text: 'Closing job' });
    job.closeJob = true;
    job.closeReason = selectedCloseOption;
    job.closeReasonDetails = details.trim() || null;
    job.save().then((success: boolean) => {
      if (success) {
        createToast({ type: 'success', key: closeKey, text: 'Successfully closed job' });
        fetchData();
        setIsSubmitting(false);
      } else {
        createToast({ type: 'error', key: closeKey, text: 'Unable to close job' });
        setIsSubmitting(false);
      }
    });
  };

  return (
    <Dialog title="Close internship" isOpen={isOpen} onClose={handleClose}>
      <Body className="mar-b-1">Please select a reason for closing this internship</Body>
      <FormGroup label="Close reason">
        <Select
          onItemSelect={handleSelect}
          items={CLOSE_REASONS}
          fill={true}
          buttonProps={{ large: true }}
          activeItem={selectedOption}
        />
      </FormGroup>
      <FormGroup label={needsDetails ? 'Details' : 'Details (optional)'}>
        <TextArea
          fill={true}
          value={details}
          onChange={(event) => setDetails(event.currentTarget.value)}
          placeholder="Anything that explains the closure"
        />
      </FormGroup>
      <Button
        fill={true}
        text="Update"
        large={true}
        disabled={!canSubmit}
        onClick={handleSubmit}
        loading={isSubmitting}
      />
    </Dialog>
  );
}
